import styled from 'styled-components';

import ListMatchTableRow from 'dashboard/components/ListMatches/ListMatchTableRow';
import TableLayout, { TableNullState, TableTH } from 'dashboard/layouts/TableLayout';
import { List } from 'dashboard/models/list';
import { ListItem } from 'dashboard/models/list-item';
import { ListMatch } from 'dashboard/models/list-match';
import { ModuleListMatches } from 'dashboard/modules/ListMatches';
import Placeholder from 'dashboard/modules/Placeholder';
import Card from 'design-system/components/Card';

interface TransactionListMatchesProps {
  lists: Record<string, List>;
  listItems: Record<string, ListItem>;
  listMatches: Record<string, ListMatch>;
  module: ModuleListMatches;
  isLoading: boolean;
}

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TransactionListMatches = ({
  module,
  isLoading,
  lists,
  listItems,
  listMatches,
}: TransactionListMatchesProps) => {
  if (isLoading) {
    return <Placeholder title='List matches' loading={true} />;
  }

  return (
    <Card data-test={`list-matches-${module.token}`}>
      <Card.Body>
        <Header>
          <Card.Title>List matches</Card.Title>
        </Header>
        <TableLayout
          dataTest={`list-matches-${module.token}__table`}
          isEmpty={Object.keys(listMatches).length === 0}
          isLoading={false}
          showHeader={Object.keys(listMatches).length > 0}
          headerTR={
            <>
              <TableTH>List name</TableTH>
              <TableTH>List type</TableTH>
              <TableTH>Matched item</TableTH>
            </>
          }
          nullState={
            <TableNullState dataTestBlock={`list-matches-${module.token}__table-null-state`}>
              There are no list matches.
            </TableNullState>
          }
        >
          {Object.values(listMatches).map((lm) => (
            <ListMatchTableRow
              list={lists[lm.relationships.list.data.id]}
              listItem={listItems[lm.relationships['list-item'].data.id]}
              listMatch={lm}
              key={lm.id}
            />
          ))}
        </TableLayout>
      </Card.Body>
    </Card>
  );
};

export default TransactionListMatches;
